<template>
    <div>
        TEST



        <div v-html="html" @click="changeInst"></div>
        <div v-if="inst" v-html="inst.getOutWrap()"></div>

        <br/>
        <br/>
        <br/>
        <br/>



        <span v-if="firstInst">
            <span v-for="(i, index) in firstInst.segmentsDisplay">
                <input v-if="index === firstInst.getFirstParamIndex()" type="text" v-model="firstParam"/>
                <span v-else-if="(firstParam || firstParam === 0) && index === firstInst.getFirstTextIndex()">
                    <span>{{firstInst.getFirstTextNeighbors('pre')}}</span>
                    <select v-model="firstOp">
                        <option v-for="j in firstParam.resops()" :value="j">{{j.name}}</option>
                    </select>
                    <span>{{firstInst.getFirstTextNeighbors('post')}}</span>
                </span>
                <input v-else-if="i.hasOwnProperty('value')" type="text" v-model="firstVals[index]" @change="forceChangeInst(firstInst, i, firstVals[index])"/>
                <span v-else>{{i.content}}</span>
            </span>
        </span>
        <span v-else>
            <input type="text" v-model="firstParam"/>
            <select v-if="firstParam || firstParam === 0" v-model="firstOp">
                <option v-for="i in firstParam.resops()" :value="i">{{i.name}}</option>
            </select>
        </span>
        <br/>
        <br/>
        <div class="output" v-if="firstInst">
            <div v-html="firstInst.getOutWrap(true)"></div>
            <div>{{firstInst.outputText('display')}}</div>
            <div>{{firstInst.outputText('display', true)}}</div>
            <div>{{firstInst.outputText()}}</div>
            <div>{{firstInst.outputText('code', true)}}</div>
        </div>



        <br/>
        <br/>
        <br/>
        <br/>



        <span v-if="secondInst">
            <span v-for="(i, index) in secondInst.segmentsDisplay">
                <select v-if="index === secondInst.getFirstParamIndex()" v-model="secondParam">
                    <option v-for="j in fields" :value="j">{{j.getLabel()}}</option>
                </select>
                <span v-else-if="(secondParam || secondParam === 0) && index === secondInst.getFirstTextIndex()">
                    <span>{{secondInst.getFirstTextNeighbors('pre')}}</span>
                    <select v-model="secondOp">
                        <option v-for="j in secondParam.resops()" :value="j">{{j.name}}</option>
                    </select>
                    <span>{{secondInst.getFirstTextNeighbors('post')}}</span>
                </span>
                <input v-else-if="i.hasOwnProperty('value')" type="text" v-model="secondVals[index]" @change="forceChangeInst(secondInst, i, secondVals[index])"/>
                <span v-else>{{i.content}}</span>
            </span>
        </span>
        <span v-else>
            <select v-model="secondParam">
                <option v-for="i in fields" :value="i">{{i.getLabel()}}</option>
            </select>
            <select v-if="secondParam || secondParam === 0" v-model="secondOp">
                <option v-for="j in secondParam.resops()" :value="j">{{j.name}}</option>
            </select>
        </span>
        <br/>
        <br/>
        <div class="output" v-if="secondInst">
            <div v-html="secondInst.getOutWrap(true)"></div>
            <div>{{secondInst.outputText('display')}}</div>
            <div>{{secondInst.outputText('display', true)}}</div>
            <div>{{secondInst.outputText()}}</div>
            <div>{{secondInst.outputText('code', true)}}</div>
        </div>





        <br/>
        <br/>
        <br/>
        <br/>



        <span v-if="thirdInst">
            <span v-for="(i, index) in thirdInst.segmentsDisplay">
                <select v-if="index === thirdInst.getFirstParamIndex()" v-model="thirdParam">
                    <option v-for="(j, jndex) in [firstInst, secondInst]" :value="j">inst_{{jndex}}</option>
                </select>
                <span v-else-if="(thirdParam || thirdParam === 0) && index === thirdInst.getFirstTextIndex()">
                    <span>{{thirdInst.getFirstTextNeighbors('pre')}}</span>
                    <select v-model="thirdOp">
                        <option v-for="j in thirdParam.resops()" :value="j">{{j.name}}</option>
                    </select>
                    <span>{{thirdInst.getFirstTextNeighbors('post')}}</span>
                </span>
                <input v-else-if="i.hasOwnProperty('value')" type="text" v-model="thirdVals[index]" @change="forceChangeInst(thirdInst, i, thirdVals[index])"/>
                <span v-else>{{i.content}}</span>
            </span>
        </span>
        <span v-else>
            <select v-model="thirdParam">
                <option v-for="(i, index) in [firstInst, secondInst]" :value="i">inst_{{index}}</option>
            </select>
            <select v-if="thirdParam || thirdParam === 0" v-model="thirdOp">
                <option v-for="j in thirdParam.resops()" :value="j">{{j.name}}</option>
            </select>
        </span>
        <br/>
        <br/>
        <div class="output" v-if="thirdInst">
            <div v-html="thirdInst.getOutWrap(true)"></div>
            <div>{{thirdInst.outputText('display')}}</div>
            <div>{{thirdInst.outputText('display', true)}}</div>
            <div>{{thirdInst.outputText()}}</div>
            <div>{{thirdInst.outputText('code', true)}}</div>
        </div>



    </div>
</template>

<script>

    import { Instance, Metadata, OP, Types } from '../../mould';

    export default {

        name: 'Test',

        data(){
            return {
                inst: null,
                html: '',
                fields: [],
                firstParam: null,
                firstOp: null,
                firstVals: [],
                secondParam: null,
                secondOp: null,
                secondVals: [],
                thirdParam: null,
                thirdOp: null,
                thirdVals: []
            }
        },

        computed: {

            firstInst(){
                if(!this.firstOp || (!this.firstParam && this.firstParam !== 0)){
                    return null;
                }
                this.firstVals = new Array(this.firstOp.getSegmentsDisplay().length);
                return new Instance({template: OP(this.firstOp.getAlias())}).setValue('$1', this.firstParam)
            },

            secondInst(){
                if(!this.secondOp || (!this.secondParam && this.secondParam !== 0)){
                    return null;
                }
                this.secondVals = new Array(this.secondOp.getSegmentsDisplay().length);
                return new Instance({template: OP(this.secondOp.getAlias())}).setValue('$1', this.secondParam)
            },

            thirdInst(){
                if(!this.thirdOp || (!this.thirdParam && this.thirdParam !== 0)){
                    return null;
                }
                this.thirdVals = new Array(this.thirdOp.getSegmentsDisplay().length);
                return new Instance({template: OP(this.thirdOp.getAlias())}).setValue('$1', this.thirdParam)
            }
        },

        mounted(){
            this.initInst();
        },

        methods: {

            initInst(){

                Instance.setWrappers({
                    wrapperText: '<span>{t}</span>',
                    wrapperConstant: '<span>{c}</span>',
                    wrapperVariable: '<span>{v}</span>',
                    wrapperInstance: '<span>{i}</span>'
                });

                this.fields = Metadata.fieldsList();

                let inst_1 = new Instance({template: OP('=')});
                let inst_2 = new Instance({template: OP('/')});
                let inst_3 = new Instance({template: OP('concat')});
                this.inst = inst_3;

                inst_1.setValue('$2', Metadata.fieldsList()[3]);
                inst_1.setValue('$1', 1);

                inst_2.setValue('$1', 100);
                inst_2.setValue('$2', inst_1);

                inst_3.setValue('$1', 'str');
                inst_3.setValue('$2', inst_2);


                console.log('\n\n------------------------------------');
                console.log(inst_3.outputText('display'));
                console.log(inst_3.outputText('display', true));
                console.log(inst_3.outputText());
                console.log(inst_3.outputText('code', true));
                this.html = inst_3.outputWrapper();
                console.log('------------------------------------\n\n');
            },

            changeInst(){
                this.inst.setValue('$1', 'another string');
            },

            forceChangeInst(inst, val, v){
                inst.setValue(val.getHolder(), v);
                this.$forceUpdate();
            },

            testType(){
                console.log(
                    Types.regTest('number', 1),
                    Types.regTest('string', 1),
                    Types.regTest('number', 'aaa'),
                    Types.regTest('boolean', true),
                    Types.regTest('date', '1999-09-01'),
                    Types.regTest('month', '1999-02'),
                    Types.regTest('year', '2009'),
                    Types.regTest('time', '2003-01-01 11:22:33')
                )
            }

        }
    }
</script>

<style scoped>
    input {
        width: 80px;
        height: 24px;
        line-height: 25px;
        text-align: center;
        margin-left: 4px;
        margin-right: 4px;
    }

    select {
        width: 80px;
        height: 30px;
        text-align: center;
        margin-left: 4px;
        margin-right: 4px;

    }
</style>